// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.scss
// module id = 147
// module chunks = 0